import Vue from 'vue';
import Vuebar from 'vuebar';
import VueCompositionApi, { provide } from '@vue/composition-api';
import { DefaultApolloClient } from '@vue/apollo-composable';
// import { plugin } from '@ideavivat/vivat-2';
import { plugin } from '@ideavivat/vivat-2';
import Highcharts from 'highcharts';
import Maps from 'highcharts/modules/map';
import HighchartsVue from 'highcharts-vue';

import App from './App.vue';
// import './registerServiceWorker';
import router from './router';
// import store from './store';
import { client } from './vue-apollo';
import i18n from './i18n';

Maps(Highcharts);
Vue.use(HighchartsVue);
Vue.use(plugin);

Vue.use(VueCompositionApi);
Vue.use(Vuebar);

(window as any).BUILD_NOTE = `${process.env.VUE_APP_BUILD_NOTE || 'HMR'}${(window as any).VIVAT_BUILD_NOTE || ''} (ระบบ${(i18n.isMain ? 'หลัก' : '')}${i18n.thisLanguage})`;
console.log('Build:', (window as any).BUILD_NOTE);

Vue.config.productionTip = false;

window.Vue = Vue;

new Vue({
  setup() {
    provide(DefaultApolloClient, client);
    return {};
  },
  router,
  // store,
  render: (h) => h(App),
}).$mount('#app');
